import { createReducer } from '../utilities';
import { REQUEST_FETCH_FULL_PLAYERS, SUCCESS_FETCH_FULL_PLAYERS, FAIL_FETCH_FULL_PLAYERS } from '../../actions/entities/player';


const initialState = {
    response: {},
    info: {
      isFetching: false,
      lastAction: null,
      lastPayload: {},
      needRefresh: true,
      updatedAt: null,
      success: false,
      error: false
  }
};

function requestFetch(state, action) {
    return {
        ...state,
        info: {
          isFetching: true,
          lastAction: action.type,
          lastPayload: action.payload,
          needRefresh: false,
          updatedAt: null,
          success: false,
          error: false
      }
    };
}

function successFetch(state, action) {
  const { payload, receivedAt, success } = action;
    return {
        ...state,
        response: action.response,
        info: {
          ...state.info,
          isFetching: false,
          lastPayload: payload,
          needRefresh: false,
          updatedAt: receivedAt,
          success,
          error: false
      }
    };
}

function failFetch(state, action) {
    const { error, payload } = action;
    return {
        ...state,
        info: {
          ...state.info,
          isFetching: false,
          lastPayload: payload,
          needRefresh: false,
          success: false,
          error
      }
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_FULL_PLAYERS]: requestFetch,
    [SUCCESS_FETCH_FULL_PLAYERS]: successFetch,
    [FAIL_FETCH_FULL_PLAYERS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/players.js